import { render, staticRenderFns } from "./StatusSetting.vue?vue&type=template&id=af93121e&"
import script from "./StatusSetting.vue?vue&type=script&lang=js&"
export * from "./StatusSetting.vue?vue&type=script&lang=js&"
import style0 from "./StatusSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports